import { render, staticRenderFns } from "./lbgg.vue?vue&type=template&id=210983be&scoped=true&"
import script from "./lbgg.vue?vue&type=script&lang=js&"
export * from "./lbgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210983be",
  null
  
)

export default component.exports